export default __webpack_public_path__ + "static/media/qeeg-4.b882c61f.png";